export default __webpack_public_path__ + "static/ellipse-glow-horizontal-3940266cb52f543d5c1863f5ba638278.png";